import { Column } from './Column';
import { Contact } from './Contact';

export class Board {
  _id = '';
  _name = '';
  _description = '';
  _owner = '';
  _guests = [];
  _members = [];
  _createdAt;
  _updatedAt;
  _columns;
  _contacts;
  _amounts = [];

  constructor(
    id,
    name,
    description,
    owner,
    guests,
    members,
    columns,
    contacts,
    createdAt,
    updatedAt,
    amounts,
  ) {
    this._id = id;
    this._name = name;
    this._description = description;
    this._owner = owner;
    this._guests = guests;
    this._members = members;
    this._columns = columns;
    this._contacts = contacts;
    this._createdAt = createdAt;
    this._updatedAt = updatedAt;
    this._amounts = amounts;
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get description() {
    return this._description;
  }

  set id(id) {
    this._id = id;
  }

  set name(name) {
    this._name = name;
  }

  set description(description) {
    this._description = description;
  }

  get owner() {
    return this._owner;
  }

  set owner(owner) {
    this._owner = owner;
  }

  get guests() {
    return this._guests;
  }

  set guests(guests) {
    this._guests = guests;
  }

  get members() {
    return this._members;
  }

  set members(members) {
    this._members = members;
  }

  get createdAt() {
    return this._createdAt;
  }

  set createdAt(createdAt) {
    this._createdAt = createdAt;
  }

  get updatedAt() {
    return this._updatedAt;
  }

  get amounts() {
    return this._amounts;
  }

  set updatedAt(updatedAt) {
    this._updatedAt = updatedAt;
  }

  get columns() {
    return this._columns;
  }

  set columns(columns) {
    this._columns = columns;
  }

  set amounts(amounts) {
    this._amounts = amounts;
  }

  get contacts() {
    return this._contacts;
  }

  set contacts(contacts) {
    this._contacts = contacts;
  }

  static fromJson(json) {
    const id = json.id || json._id || '';
    return new Board(
      id,
      json.name,
      json.description,
      json.owner,
      json.guests,
      json.members,
      json.columns?.map((column) => Column.fromJson(column)) || [],
      json.contacts?.map((contact) => Contact.fromJson(contact)) || [],
      json.createdAt,
      json.updatedAt,
      json.amounts || [],
    );
  }

  toJson() {
    return {
      id: this._id,
      name: this._name,
      description: this._description,
      owner: this._owner,
      guests: this._guests,
      members: this._members,
      columns: this._columns.map((column) => column.toJson()),
      contacts: this._contacts.map((contact) => contact.toJson()),
      createdAt: this._createdAt,
      updatedAt: this._updatedAt,
      amounts: this._amounts,
    };
  }

  clone() {
    return new Board(
      this._id,
      this._name,
      this._description,
      this._owner,
      this._guests,
      this._members,
      this._columns.map((column) => column.clone()),
      this._contacts.map((contact) => contact.clone()),
      this._createdAt,
      this._updatedAt,
      this._amounts,
    );
  }
}
